import script from "./DocumentTextIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentTextIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__